import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenuItem } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { hasPortalAccessAtCustomer } from './ContactsDashboardRow.utils';
export const ClientPortalMenuItem = (param)=>{
    let { customer, onClick, testId } = param;
    const { t } = useLocaleKeys('client.contactsDashboard');
    const hasPortalAccess = hasPortalAccessAtCustomer(customer);
    return /*#__PURE__*/ _jsx(DropdownMenuItem, {
        bi: {
            name: 'contact_view_client_portal_client'
        },
        testId: testId,
        disabled: !hasPortalAccess,
        tooltipProps: hasPortalAccess ? undefined : {
            title: t.noPortalAccessTooltip(),
            placement: 'left'
        },
        onClick: ()=>onClick(customer.customerId),
        children: customer.customerName
    });
};
